/**
 * Query keys do REPASSE dos parceiros com validação (Wellhub e TotalPass) —
 * aba "Repasse" de /agregadores no CRM (`useWellhubRepasse`).
 *
 * A RAIZ É `['wellhub_repasse']`, a mesma do `WELLHUB_REPASSE_KEY` que as
 * mutações do repasse (salvar condição, adicionar aluno, fechamento) já
 * invalidam: o nome é histórico (nasceu só Wellhub) e TROCÁ-LO quebraria o
 * prefix-match de quem invalida a raiz. O parceiro entra como componente da
 * chave, nunca como raiz própria — invalidar `repasse.all` relê os dois.
 */
import { tuple } from "./core";

const root = ["wellhub_repasse"] as const;

export const repasse = {
  /** Prefixo raiz — toda mutação do repasse invalida isto (cobre tudo abaixo). */
  all: root,
  /** O mês do repasse, por visitante (RPC `wellhub_repasse_do_mes`). */
  mes: (clubId: string | null | undefined, competencia: string, parceiro: string | null) =>
    tuple(root, "mes", clubId, competencia, parceiro),
  /** Condições comerciais do parceiro no clube (`aggregator_product_rates`). */
  condicoes: (clubId: string | null | undefined, parceiro: string | null) =>
    tuple(root, "condicoes", clubId, parceiro),
  /** Fechamento da competência (RPC `wellhub_fechamento_do_mes`, fase 2). */
  fechamento: (clubId: string | null | undefined, competencia: string) =>
    tuple(root, "fechamento", clubId, competencia),
} as const;
